var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticStyle:{"height":"60px","width":"60px"}},[_c('img',{attrs:{"src":_vm.image,"height":_vm.height}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }